module.exports = __webpack_public_path__ + "img/01.aa2d9a76.jpg";